export enum ItemCategory {
  alcohol = 'alcoholic_beverage',
  drink = 'non_alcoholic_beverage',
  pizza = 'pizza',
  food = 'food',
}
